var heading_default = {
  "fontElementMap": "-idvf",
  "elementSpacing": "E5Uwj",
  "headerOne": "_4ZqYa E5Uwj",
  "headerTwo": "_-9WIk E5Uwj",
  "headerThree": "YW9w3 E5Uwj",
  "headerFour": "_1a8lC E5Uwj",
  "headerFive": "W4n-t E5Uwj",
  "headerSix": "Ld1WW E5Uwj",
  "child": "LDa7h"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
